import { PrivateCreditRelatedArticlesQuery } from './queries/private-credit-marketing-page';
import { SanityRelatedArticlesSection } from 'types/sanity/education-center';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

interface SanityPrivateCreditRelatedArticlesResponse {
	allPrivateCreditLandingPage: Array<{
		investorUpdatesSection: SanityRelatedArticlesSection;
	}>;
}

export async function getPrivateCreditRelatedArticles(): Promise<SanityRelatedArticlesSection | null> {
	const { data } = await useQuery<SanityPrivateCreditRelatedArticlesResponse>({
		client: villusClient,
		query: PrivateCreditRelatedArticlesQuery,
		tags: ['private_credit_marketing_page']
	}).execute();

	const privateCreditMarketingPage = data?.allPrivateCreditLandingPage[0].investorUpdatesSection;
	return privateCreditMarketingPage ?? null;
}
